import $ from "cash-dom";
import { fetchHTML } from "Utilities";

export default (function () {
    $(document).ready(function () {
        if ($(".category-filter").length) {
            $(".category-filter a").on("click", function (_e) {
                var links = $(".category-filter a");
                var link = $(this);
                var url = link.attr("href");

                console.log(link, links, url);

                if (window.location.href == url) return false;

                var oldHead = $("head");
                var metaSelector = ":not(link[rel='stylesheet'], script, style)";
                var oldPosts = $(".post-list");

                _e.preventDefault();

                fetchHTML({
                    url: url,
                    beforeSend: function () {
                        links.removeClass("underline");
                        link.addClass("underline");
                        oldPosts.addClass("fade-out transition-md on");
                    },
                    complete: function (_html) {
                        if (_html) {
                            var parser = new DOMParser();
                            var html = $(parser.parseFromString(_html, "text/html"));
                            var newMeta = html.find("head").find(metaSelector);
                            var newPosts = html.find(".post-list");
                            var state = {
                                url: url,
                            };

                            oldHead.find(metaSelector).remove();
                            oldHead.append(newMeta);
                            newPosts.addClass("fade-in transition-md");
                            oldPosts.replaceWith(newPosts);

                            setTimeout(function () {
                                newPosts.addClass("on");
                            }, 50);

                            history.pushState(state, null, url);
                            $(window).trigger("fetchSuccess");
                        }
                    },
                    error: function (_error) {
                        console.log(_error);
                    },
                });
            });
        }

        $(window).on("popstate", function (_e) {
            if (_e.state) {
                window.location.href = _e.state.url;
            }
        });
    });
})();
